<template>
  <!-- 🔴 БЛОК ДЕРЖИТ ПОСТОЯННУЮ ВЫСОТУ (`min-height`): он живёт в лобби, а карточка лобби
       ЦЕНТРИРУЕТСЯ ПО ВЕРТИКАЛИ — выросшая на строку плашка сдвинула бы заголовок, кнопки фракций
       и «В бой» (жалоба оунера 2026-08-30 «интерфейс постоянно прыгает»). Переход
       «обрабатывается → поздравляем» меняет ТОЛЬКО текст, но текст разной длины переносится
       по-разному, поэтому высоту задаём, а не выводим из содержимого. -->
  <div v-if="row" class="sord" :class="'sord--' + row.state">
    <span class="sord__ico">{{ icon }}</span>
    <div class="sord__body">
      <div class="sord__title">{{ title }}</div>
      <p class="sord__hint">{{ hint }}</p>
    </div>
    <!-- Крестик у КАЖДОГО сообщения — то же правило, что в блоке NFT профиля (решение оунера
         2026-09-11). 24×24 и вне потока: мельче на телефоне не нажимается, а в потоке он уезжал
         под своё же сообщение. -->
    <button class="sord__x" type="button" :title="$t('stars.orderClose')" :aria-label="$t('stars.orderClose')" @click="close">✕</button>
  </div>
</template>

<script>
// СТРОКА СОСТОЯНИЯ ПОКУПКИ ЗА ЗВЁЗДЫ (просьба оунера 2026-09-15: «информационная строка обработки
// транзакции в разделе PVP, как сейчас при обмене ENRG; не прошла — сообщение об ошибке в этом же
// блоке, успешно — поздравление с успешной покупкой»).
//
// 🔴 ТРИ ИСХОДА, И ОНИ НЕ ОДНО И ТО ЖЕ:
//   обрабатывается — счёт открыт в Telegram, сервер подтверждения ещё не дал;
//   выдано         — сервер записал покупку и выдал товар (это и есть поздравление);
//   не прошла      — сервер ЗНАЕТ про оплату и товар не выдал (`status !== paid`);
//   не увидели     — прошёл срок, а подтверждения нет. Про оплату мы не знаем НИЧЕГО, и писать
//                    «оплата не прошла» здесь было бы выдумкой: звёзды могли списаться.
//
// 🔴 СУДЬЯ — СЕРВЕР, А НЕ БРАУЗЕР. Строка только СПРАШИВАЕТ (`/stars/claim` + `/stars/history`), и
// «выдано» печатает по записи сервера. Локальная заявка помнит лишь то, что игрок пошёл платить.
import {
  readOrder, setOrderState, clearOrder, orderExpired, orderMatches,
  ORDER_PENDING, ORDER_DONE, ORDER_FAILED, ORDER_TIMEOUT,
} from '@/starsOrder';

// Как часто спрашиваем сервер, пока оплата в пути. Десять секунд: выдача обычно приходит за
// секунды, а строка живёт на экране, где и без неё хватает опросов.
const POLL_MS = 10000;

// 🔴 БЫСТРУЮ ВЫДАЧУ ДЁРГАЕМ ОГРАНИЧЕННОЕ ЧИСЛО РАЗ: `POST /stars/claim` ходит в САМ Telegram, а у
// прода теряется ~10% таких запросов. Дальше хватает истории покупок — товар всё равно принесёт
// апдейт бота-шлюза, это штатный путь выдачи.
const CLAIM_TRIES = 6;

export default {
  name: 'StarsOrderLine',
  data() {
    return {
      row: null,
      timer: null,
      busy: false,
      claims: 0,
      shopOff: false,   // касса выключена в админке (роут ответил 404) — спрашивать больше нечего
    };
  },
  computed: {
    icon() {
      if (this.row.state === ORDER_DONE) return '🎉';
      if (this.row.state === ORDER_FAILED) return '⚠️';
      if (this.row.state === ORDER_TIMEOUT) return '❓';
      return '⏳';
    },
    title() {
      const p = { title: this.row.title, n: this.row.stars };
      if (this.row.state === ORDER_DONE) return this.$t('stars.orderDone', p);
      if (this.row.state === ORDER_FAILED) return this.$t('stars.orderFailed', p);
      if (this.row.state === ORDER_TIMEOUT) return this.$t('stars.orderTimeout', p);
      return this.$t('stars.orderPending', p);
    },
    hint() {
      if (this.row.state === ORDER_DONE) return this.$t('stars.orderDoneHint');
      if (this.row.state === ORDER_FAILED) return this.$t('stars.orderFailedHint');
      if (this.row.state === ORDER_TIMEOUT) return this.$t('stars.orderTimeoutHint');
      return this.$t('stars.orderPendingHint');
    },
    userId() { return this.$store.state.auth.id; },
  },
  watch: {
    // Игрок опознался позже монтирования (обычный порядок: экран рисуется раньше ответа про него).
    userId() { this.refresh(); },
  },
  mounted() {
    this.refresh();
    document.addEventListener('visibilitychange', this.onVisible);
  },
  beforeUnmount() {
    this.stop();
    document.removeEventListener('visibilitychange', this.onVisible);
  },
  methods: {
    refresh() {
      this.row = readOrder(this.userId);
      if (this.row && orderExpired(this.row)) this.row = setOrderState(this.userId, ORDER_TIMEOUT);
      if (this.row && this.row.state === ORDER_PENDING) this.start();
      else this.stop();
    },
    start() {
      if (this.timer || this.shopOff) return;
      this.poll();
      this.timer = setInterval(this.poll, POLL_MS);
    },
    stop() {
      if (this.timer) clearInterval(this.timer);
      this.timer = null;
    },
    // Возврат на вкладку — самый частый момент, когда оплата уже прошла: игрок буквально сейчас
    // пришёл из Telegram. Ждать до следующего тика таймера незачем.
    onVisible() {
      if (document.visibilityState !== 'visible') return;
      if (this.row && this.row.state === ORDER_PENDING) this.poll();
    },
    async poll() {
      if (this.busy || !this.row || this.row.state !== ORDER_PENDING) return;
      if (orderExpired(this.row)) { this.row = setOrderState(this.userId, ORDER_TIMEOUT); this.stop(); return; }
      this.busy = true;
      try {
        // Быстрая выдача: сервер спрашивает историю звёзд у самого Telegram и выдаёт найденный
        // заказ, не дожидаясь апдейта шлюза. Отказ тут не важен — дальше смотрим историю покупок.
        if (this.claims < CLAIM_TRIES) {
          this.claims += 1;
          try { await this.axios.post('/stars/claim'); } catch (e) { /* молча: это ускорение, а не путь */ }
        }
        const { data } = await this.axios.get('/stars/history');
        const items = (data && data.items) || [];
        const mine = items.find((r) => orderMatches(this.row, r));
        if (!mine) return;
        // 🔴 «Запись есть» ≠ «товар выдан»: оплату сервер мог пометить неудачной, и поздравление
        // отправило бы игрока искать то, чего ему не дали.
        const ok = !mine.status || mine.status === 'paid';
        this.row = setOrderState(this.userId, ok ? ORDER_DONE : ORDER_FAILED);
        this.stop();
        this.$emit('done', { purchase: mine, ok });
      } catch (e) {
        const status = e && e.response && e.response.status;
        if (status === 404) { this.shopOff = true; this.stop(); }   // касса выключена
      } finally {
        this.busy = false;
      }
    },
    close() {
      clearOrder();
      this.row = null;
      this.stop();
    },
  },
};
</script>

<style scoped lang="scss">
.sord {
  position: relative;
  display: flex;
  align-items: center;
  gap: 0.7em;
  width: 100%;
  max-width: 460px;
  min-height: 56px;
  margin: 0.7em auto 0.2em;
  padding: 0.55em 2.1em 0.55em 0.85em;   // справа — место под крестик, он вне потока
  box-sizing: border-box;
  border-radius: 12px;
  border: 1px solid rgba(255, 200, 90, 0.4);
  background: rgba(0, 0, 0, 0.32);
  color: #eee;
  text-align: left;

  &--done { border-color: rgba(120, 220, 150, 0.55); }
  &--failed { border-color: rgba(255, 130, 110, 0.6); }
  &--timeout { border-color: rgba(160, 180, 255, 0.5); }
}

.sord__ico { font-size: 1.4em; flex: 0 0 auto; }
.sord__body { flex: 1 1 auto; min-width: 0; }
.sord__title { font-size: 0.86em; font-weight: 600; line-height: 1.25; }
.sord__hint { margin: 0.15em 0 0; font-size: 0.74em; line-height: 1.25; opacity: 0.82; }

.sord__x {
  position: absolute;
  top: 4px;
  right: 4px;
  width: 24px;
  height: 24px;
  padding: 0;
  line-height: 22px;
  border: 1px solid rgba(255, 255, 255, 0.25);
  border-radius: 7px;
  background: rgba(0, 0, 0, 0.35);
  color: #eee;
  font-size: 0.8em;
  cursor: pointer;
}
</style>
